import * as React from "react";
import AppBar from "@mui/material/AppBar";
import { useTheme } from "@emotion/react";
import drawerDim from "../../../theme/drawerDimensions";
import { Box } from "@mui/material";
import { t } from "i18next";

function BottomBar(props) {
  const theme = useTheme();
  return (
    <AppBar
      position="fixed"
      elevation={0}
      component="footer"
      sx={{
        width: { md: `calc(100% - ${drawerDim.width}px)` },
        ml: { md: `${drawerDim.width}px` },
        bottom: 0,
        top: "auto",
        height: `${drawerDim.bottom}px`,
        letterSpacing: "2px",
        display: "flex",
        alignItems: "center",
        flexDirection: theme.direction === "rtl" ? "row-reverse" : "row",
        justifyContent: "flex-end",
        px: 5,
        color: theme.palette.text.main,
        background: theme.palette.whiteblack.main,
        fontWeight: 300,
        fontSize: "0.875rem",
      }}
    >
      <Box sx={{ p: 1, color: theme.palette.primary.main }}>&#169;</Box>{" "}
      {t("copyright")}
    </AppBar>
  );
}

export default BottomBar;
